import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { coreEntityMissingDialogAtom } from '../../store/coreEntityMissingStore';
import ConfirmationDialog from '../ConfirmationDialog/ConfirmationDialog';
import { useTabNavigation } from '../../store/mainTabsStore';

function CoreEntityMissingDialog() {
  const [dialog, setDialog] = useAtom(coreEntityMissingDialogAtom);
  const { removeTab } = useTabNavigation();

  useEffect(() => {
    if (dialog.open) {
      const handleEscape = (e: KeyboardEvent) => {
        if (e.key === 'Escape') {
          handleClose();
        }
      };
      window.addEventListener('keydown', handleEscape);
      return () => window.removeEventListener('keydown', handleEscape);
    }
  }, [dialog.open]);

  const closeAllOpenDialogs = () => {
    const backdrops = document.querySelectorAll('.MuiBackdrop-root');
    backdrops.forEach((backdrop) => {
      (backdrop as HTMLElement).click();
    });
  };

  const handleClose = () => {
    const contextUrl = dialog.contextUrl;
    setDialog({ open: false, title: '', message: '' });

    if (contextUrl) {
      removeTab(contextUrl);
    }

    setTimeout(() => {
      closeAllOpenDialogs();
    }, 0);
  };

  return (
    <ConfirmationDialog
      state="error"
      open={dialog.open}
      title={dialog.title}
      content={dialog.message}
      confirmButton={{
        text: 'Ok',
        onClick: handleClose,
      }}
      onClose={handleClose}
    />
  );
}

export default CoreEntityMissingDialog;
